import React from 'react';
import './section9.css';
import TextCard from '../common/TextCard';
import ImageCard from '../common/ImageCard';
import Title from '../common/title';

import studioImg from '../../asserts/1.png';
import penthouseImg from '../../asserts/2.png';
import twoBedImg from '../../asserts/3.png';

const Sec9 = () => {
    return ( 
        <section className="section9-container">
        <div className="section9-inner">
          <Title title="Villas Categories" t="title" />
          
          <div className="categories-grid">
            <TextCard 
              category="Studio Villas" 
              features={[
                "Smartly designed layouts maximize functionality and comfort.",
                "Modern interiors with stylish finishes and efficient storage solutions.",
                "Ideal for professionals or students seeking a low-maintenance home."
              ]} 
            />
            <ImageCard src={studioImg} alt="Studio Villa" />
  
            <ImageCard src={penthouseImg} alt="Penthouse Suite" />
            <TextCard 
              category="Penthouse Suites" 
              features={[
                "Expansive floor plans with premium finishes and top-tier appliances.",
                "Private terraces or balconies offering breathtaking city or landscape views.",
                "Exclusive access to high-end amenities such as rooftop pools or lounges."
              ]} 
            />
  

            <TextCard 
              category="Two-Bedroom Villas" 
              features={[
                "Thoughtfully designed bedrooms offering privacy and relaxation.",
                "Open-concept living areas perfect for gatherings or family time.",
                "Equipped with modern kitchens and ample storage space."
              ]} 
            />
            <ImageCard src={twoBedImg} alt="Two-Bedroom Villa" />
          </div>
        </div>
      </section> 
     );
}
 
export default Sec9;